import { Global } from '@emotion/react'
import { Fragment, type ReactNode } from 'react'

import { fontStyles } from './font-styles'

interface Props {
  element: ReactNode
}

export const wrapWithGlobalStyles = ({ element }: Props) => {
  return (
    <Fragment>
      <Global styles={fontStyles} />
      {element}
    </Fragment>
  )
}
